export class BookingRedirectHelper {
	/**
	 * Generates the correct booking tool redirect url based on the provided parameters.
	 * @param bookingToolUrl The base URL of the booking tool.
	 * @param hotelSlug The slug of the hotel.
	 * @param roomGuid The GUID of the room.
	 * @param dealGuid The GUID of the deal.
	 * @param promotionCode The promotion code to apply.
	 * @param languageCode The language code to use in the bookingtool.
	 *
	 * @returns The complete redirect URL for the booking tool.
	 */
	static getRedirectUrl(
		bookingToolUrl: string,
		hotelSlug: string,
		roomGuid: string,
		dealGuid: string,
		promotionCode: string,
		languageCode: string,
	): string {
		let redirectUrl = bookingToolUrl;

		if (hotelSlug) {
			redirectUrl += '?hotelSlug=' + hotelSlug;
		} else {
			// Redirect will not work without a hotel slug
			return bookingToolUrl;
		}
		if (roomGuid) {
			redirectUrl += '&roomGUID=' + roomGuid;
		}
		if (dealGuid) {
			redirectUrl += '&dealGUID=' + dealGuid;
		}
		if (promotionCode) {
			redirectUrl += '&promotionCode=' + promotionCode;
		}
		if (languageCode) {
			redirectUrl += '&languageCode=' + languageCode;
		}

		return redirectUrl;
	}
}
